import { GenericResponse } from '@omnea-digital/toolbox'
import createClient from 'openapi-fetch'
import { withErrorCapture } from '@omnea-app/legacy/utils/general/observability/withErrorCapture'
import { ServiceUrls } from '@omnea-app/legacy/utils/general/serviceUrls'
import { paths } from './orgSettingsGeneratedTypes'

interface Params {
  authorization: string
}
export class OrgSettingsHttpClient {
  GET
  POST
  constructor({ authorization }: Params) {
    const { GET, POST } = createClient<paths>({
      baseUrl: ServiceUrls.ORG_SETTINGS,
      headers: { Authorization: authorization },
    })
    this.GET = withErrorCapture({ method: GET })
    this.POST = withErrorCapture({ method: POST })
  }
}

export type OrganisationSettingsResponse<T extends keyof paths, T2 extends keyof paths[T]> = GenericResponse<paths, T, T2>
